import { leaseCompanyMst, mstCommon } from '@libs/domain';
import { Characters, Item } from '@ps-smart-cp/ppfw-client';
import { useMstSettings } from '../../../context';

export function useLeaseCompanyItems() {
  const { leaseCompany } = useMstSettings();
  const attr = Characters.preset.halfWidth({
    minLen: +leaseCompany.codeDigits,
    maxLen: +leaseCompany.codeDigits,
    required: true,
  });

  return {
    code: Item.of(mstCommon.names.code, attr),
    laCompanyMstCode: Item.of(leaseCompanyMst.names.laCompanyMstCode, attr),
    laCompanyMstCodeNotRequired: Item.of(leaseCompanyMst.names.laCompanyMstCode, attr.replaceRequired(false)),
    laCompanyAfterChange: Item.of(leaseCompanyMst.names.laCompanyAfterChange, attr.replaceRequired(false)),
  };
}
